import { NavigateManageInitialState } from "./action";

export const NavigateManageReducer = (state = NavigateManageInitialState, action) => {
	return {
		...state
	};
}